var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxTrashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 4.5026H5.16667V4.0026V2.66927C5.16667 2.21008 5.54081 1.83594 6 1.83594H10C10.4592 1.83594 10.8333 2.21008 10.8333 2.66927V4.0026V4.5026H11.3333H13.5V4.83594H12.6667H12.1667V5.33594V13.3359C12.1667 13.7951 11.7925 14.1693 11.3333 14.1693H4.66667C4.20748 14.1693 3.83333 13.7951 3.83333 13.3359V5.33594V4.83594H3.33333H2.5V4.5026H4.66667ZM6 2.16927H5.5V2.66927V4.0026V4.5026H6H10H10.5V4.0026V2.66927V2.16927H10H6ZM11.3333 13.8359H11.8333V13.3359V5.33594V4.83594H11.3333H4.66667H4.16667V5.33594V13.3359V13.8359H4.66667H11.3333Z",
    stroke: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTrashAlt);
export default __webpack_public_path__ + "static/media/bx-trash-alt.bab631c5205ad2216a1a4a75ef429db3.svg";
export { ForwardRef as ReactComponent };